import { eventSchema, type Dataset, type GoogleCalendar, type SyncOperation } from "@otrack/domain";
import { writableCalendars } from "./google";
import { googleCreate, type PendingChange } from "./google-events";

/**
 * Sends the Events that `operations` create to the Google calendar Settings picks for new events
 * ("New events go to"), when it picks one ontrack can write to. The Command Bar and the assistant
 * plan Events the usual way; this decides where they land. Other operations pass through.
 */
export function routeNewEvents(operations: readonly SyncOperation[], dataset: Dataset, calendars: readonly GoogleCalendar[]): { operations: SyncOperation[]; google: PendingChange[]; calendar: GoogleCalendar | null } {
  const calendar = writableCalendars(calendars).find((item) => item.id === dataset.settings.newEventsCalendar) ?? null;
  if (!calendar) return { operations: [...operations], google: [], calendar: null };
  const kept: SyncOperation[] = [];
  const google: PendingChange[] = [];
  for (const operation of operations) {
    const created = operation.entityType === "event" && !dataset.events[operation.entityId]
      ? eventSchema.safeParse({ id: operation.entityId, createdAt: 0, updatedAt: 0, deletedAt: null, discardedAt: null, fieldClocks: {}, ...operation.patch })
      : null;
    if (!created?.success || created.data.seriesId !== null) { kept.push(operation); continue; }
    const event = created.data;
    google.push(googleCreate(calendar.id, { title: event.title, notes: event.notes, location: "", projectId: event.projectId, taskId: event.taskId, allDay: event.allDay, start: event.start, end: event.end, repeat: event.repeat }));
  }
  return { operations: kept, google, calendar: google.length ? calendar : null };
}
